'use client';
var classes = {"root":"m_515a97f8"};

export { classes as default };
//# sourceMappingURL=VisuallyHidden.module.css.mjs.map
